import MuiPopover from '@mui/material/Popover';
import { Button } from '@src/common/components/button/Button';
import { css } from '@src/common/styles/Styles';
import type { ComponentProps, ReactElement } from 'react';
import { useState } from 'react';

type Props = Omit<ComponentProps<typeof MuiPopover>, 'open'> & {
  openPopoverComponent: ReactElement | string;
  openPopoverProps?: Partial<ComponentProps<typeof Button>>;
};

export const Popover = (props: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { openPopoverComponent, openPopoverProps, children, ...rest } = props;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="text"
        onClick={handleClick}
        disableRipple={true}
        className={open ? ActiveButton : undefined}
        {...openPopoverProps}
      >
        {openPopoverComponent}
      </Button>

      <MuiPopover
        {...rest}
        anchorEl={anchorEl}
        onClose={handleClose}
        open={open}
        id={open ? 'tooltip' : undefined}
      >
        {children}
      </MuiPopover>
    </div>
  );
};

const ActiveButton = css(() => ({
  background: '#E9EBF1',
}));
